import LockIcon from "@ch/assets/icons/pack/LockIcon";
import { useNavigate } from "react-router-dom";

const MessageLimit = () => {
  const navigate = useNavigate();

  return (
    <div className="flex w-full min-w-0 flex-col items-center gap-3 rounded-2xl border border-[#FD6E5E] bg-[#FFEBE8] px-4 py-5 text-center sm:gap-4 sm:px-6 sm:py-7">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#FD6E5E]">
        <LockIcon />
      </div>
      <div className="flex w-full min-w-0 flex-col gap-1">
        <h2 className="text-base font-medium leading-snug text-[#101828] sm:text-lg">
          You have used all your free Kem messages
        </h2>
        <p className="text-sm leading-relaxed text-[#6A7282]">
          Subscribe to continue chatting with Kem.
        </p>
      </div>
      <button
        className="w-full max-w-xs rounded-md bg-[#FD6E5E] px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#e55d4d] sm:w-auto sm:py-2"
        onClick={() => {
          void navigate("/subscriptions");
        }}
        type="button"
      >
        Subscribe
      </button>
    </div>
  );
};

export default MessageLimit;
